import React from "react";

import MaterialTable from "material-table";

import { VISA_LIST } from "../../../../scripts/const";

export default function VisaList() {
  const getColumns = () => {
    return [
      {
        title: "Visa Type",
        field: "visaType",
      },
    ];
  };

  const [data] = React.useState(VISA_LIST);

  return (
    <MaterialTable
      title="Visa Type List"
      columns={getColumns()}
      data={data.map((d) => ({
        visaType: d,
      }))}
      options={{
        exportButton: true,
        pageSize: 50,
        pageSizeOptions: [50, 100],
        headerStyle: {
          backgroundColor: "#0077c2",
          color: "#FFF",
        },
        sorting: true,
      }}
    />
  );
}
